import { FormattedMessage } from 'react-intl';

import SmsIcon from '@/assets/icons/annotation.svg';
import MailIcon from '@/assets/icons/mail.svg';
import { Skeleton } from '@/components/ui/skeleton';
import { Typography } from '@/components/ui/typography';

import { Dates } from '../form-elements/dates';

interface CampaignDetailsProps {
  campaignType: 'email' | 'sms';
  displayCampaignType: string;
  audienceName: string;
  isFetching: boolean;
}

export function CampaignDetails({
  campaignType,
  displayCampaignType,
  audienceName,
  isFetching,
}: CampaignDetailsProps) {
  return (
    <div className="flex flex-col gap-2">
      <Typography variant="caption">
        <FormattedMessage
          defaultMessage="Campaign details"
          description="Campaign details caption"
        />
      </Typography>

      {/* Campaign type - Email/SMS */}
      <div className="flex items-center justify-between gap-4">
        <Typography variant="subtitle2">
          <FormattedMessage
            defaultMessage="Channel"
            description="Title for email/SMS channel"
          />
        </Typography>
        {isFetching ? (
          <Skeleton className="h-4 w-14" />
        ) : (
          <div className="flex items-center gap-1">
            <img
              src={campaignType === 'email' ? MailIcon : SmsIcon}
              alt={displayCampaignType}
              className="h-4 w-4"
            />
            <Typography variant="small1">{displayCampaignType}</Typography>
          </div>
        )}
      </div>

      {/* Audience name */}
      <div className="flex items-center justify-between gap-4">
        <Typography variant="subtitle2">
          <FormattedMessage
            defaultMessage="Audience"
            description="Title for audience name"
          />
        </Typography>
        {isFetching ? (
          <Skeleton className="h-4 w-20" />
        ) : (
          <Typography variant="small1">{audienceName}</Typography>
        )}
      </div>

      <Dates />
    </div>
  );
}
